import httpManager from "@/app/shared/utils/httpManager";

export async function downloadStrategy(strategyId) {
  const response = await httpManager.getBlob(`/strategies/${strategyId}/download/`);
  return response;
}
